if (!customElements.get('color-picker-grid')) {
  customElements.define(
    'color-picker-grid',
    class ColorPickerGrid extends HTMLElement {
      connectedCallback() {
        this.currentLabel = this.querySelector('[data-current-color-name]');
        this.handleClick = this.handleClick.bind(this);
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }


      handleClick(event) {
        const swatch = event.target.closest('[data-swatch]');
        if (!swatch) return;
        this.selectSwatch(swatch);
      }

      selectSwatch(swatch) {
        if (swatch.classList.contains('is-active')) return;

        const url = swatch.dataset.productUrl;
        const name = swatch.dataset.colorName;
        if (!url) return;

        this.querySelectorAll('[data-swatch].is-active').forEach((el) => {
          el.classList.remove('is-active');
          el.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('is-active');
        swatch.setAttribute('aria-pressed', 'true');

        if (this.currentLabel && name) this.currentLabel.textContent = name;

        this.dispatchEvent(
          new CustomEvent('product:rerender', {
            bubbles: true,
            detail: { url },
          })
        );
      }
    }
  );
}
